import type { FC } from 'react';

import { DisplayType } from '@mopla/data-models';

import { HomeIcon, StationIcon, VirtualStop } from '../../icons';

export interface IRidePointIconProps {
	pointType?: DisplayType;
}

export const RidePointIcon: FC<IRidePointIconProps> = ({ pointType }) => {
	if (pointType === DisplayType.VIRTUAL_STOP) {
		return <VirtualStop />;
	}

	if (pointType === DisplayType.STOP) {
		return <StationIcon />;
	}

	return <HomeIcon />;
};
